import {
    ALGOLIA_APP_ID,
    ALGOLIA_SEARCH_KEY,
    ALGOLIA_INDEX,
    ALGOLIA_INDEX_BY_DATE
} from "./constants";

import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import { configure, refinementList, clearRefinements, hits } from 'instantsearch.js/es/widgets';
import { history } from 'instantsearch.js/es/lib/routers';
import { connectSearchBox, connectStats, connectSortBy } from 'instantsearch.js/es/connectors'

import aa from 'search-insights'
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'

let searchStoredQuery = '';

function flattenObject(ob) {
    var toReturn = {};

    for (var i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if ((typeof ob[i]) == 'object' && ob[i] !== null) {
            var flatObject = flattenObject(ob[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;

                toReturn[i + '.' + x] = flatObject[x];
            }
        } else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
}

class AlgoliaSearch {
    constructor() {
        this.clientId = ALGOLIA_APP_ID;
        this.apiKey = ALGOLIA_SEARCH_KEY;
        this.index = window.search_index || ALGOLIA_INDEX;
        this.indexByDate = window.search_index_date || ALGOLIA_INDEX_BY_DATE;
        this.authorIndex = 0;
        this.init();
    }

    init() {
        const searchNoResults = document.getElementById('search-no-results');
        const searchWrapper = document.getElementById('advanced-search-wrapper');
        const buttonSuggestions = document.querySelectorAll('[data-search-suggestion]');
        this.searchResults = document.querySelector('#search-adv-results');
        this.searchResultsSuggested = document.querySelector('#search-adv-results-suggested');
        this.buttonMore = document.getElementById('search-button-more');
        this.buttonMoreSuggested = document.getElementById('search-button-more-suggested');

        const searchOpener = $('.search-opener');
        searchOpener.on('click', (event) => {
            event.preventDefault();
            document.getElementById('search-adv-input').focus();
            searchWrapper.classList.add('focus');
        });

        const algoliaClient = algoliasearch(this.clientId, this.apiKey);

        const indexName = window.search_index;

        Array.from(buttonSuggestions).forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const suggestion = event.target.dataset.searchSuggestion;
                const input = document.getElementById('search-adv-input');
                input.value = suggestion;
                this.search.helper.state.query = suggestion;
                this.search.refresh();
                input.focus();
            })
        });

        this.search = instantsearch({
            indexName: this.index,
            searchClient: algoliaClient,
            searchFunction: (helper) => {
                const filters = flattenObject(helper.state.disjunctiveFacetsRefinements);
                const hasFilters = Object.keys(filters).length !== 0;
                const hasQuery = helper.state.query.length > 0;

                if(helper.state.query.length > 2) {
                    helper.setQueryParameter('optionalFilters', ['is_featured_author:true', 'is_featured:true']);
                } else {
                    helper.setQueryParameter('optionalFilters', ['is_featured:true']);
                }

                if(this.searchResultsSuggested) {
                    if(hasQuery || hasFilters) {
                        this.searchResults.classList.remove('hide-results')
                        if(this.searchResultsSuggested) {
                            this.searchResultsSuggested.classList.add('hide-results')
                        }

                        this.buttonMore.classList.remove('hide-results')
                        if(this.buttonMoreSuggested) {
                            this.buttonMoreSuggested.classList.add('hide-results')
                        }
                    } else {
                        this.searchResults.classList.add('hide-results')
                        if(this.searchResultsSuggested) {
                            this.searchResultsSuggested.classList.remove('hide-results')
                        }
                        this.buttonMore.classList.add('hide-results')
                        if(this.buttonMoreSuggested) {
                            this.buttonMoreSuggested.classList.remove('hide-results')
                        }
                    }
                } else {
                    this.searchResults.classList.remove('hide-results')
                    this.buttonMore.classList.remove('hide-results')
                    if(this.buttonMoreSuggested) {
                        this.buttonMoreSuggested.classList.add('hide-results')
                    }
                }
                this.appendPosts = !!(helper.state.query.length < 1 && window.featured_posts_list);
                helper.search();
            },
            routing: {
                router: history({
                    createURL({ qsModule, routeState, location }) {
                        const urlParts = location.href.match(/^(.*?)\/search/);
                        const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

                        const queryParameters = {};

                        if (routeState.query) {
                            queryParameters.query = routeState.query;
                        }

                        if (routeState.type) {
                            queryParameters.type = routeState.type.map(encodeURIComponent);
                        }

                        if (routeState.year) {
                            queryParameters.years = routeState.year.map(encodeURIComponent);
                        }

                        if (routeState.categories) {
                            queryParameters.categories = routeState.categories.map(encodeURIComponent);
                        }

                        const queryString = qsModule.stringify(queryParameters, {
                            addQueryPrefix: true,
                            arrayFormat: 'repeat'
                        });

                        return `${baseUrl}search/${queryString}`;
                    },

                    parseURL({ qsModule, location }) {

                        const { query = '', type = [], categories = [], years = [] } = qsModule.parse(
                            location.search.slice(1)
                        );

                        const allYear = Array.isArray(years)
                            ? years
                            : [years].filter(Boolean);

                        const allTypes = Array.isArray(type)
                            ? type
                            : [type].filter(Boolean);

                        const allCategories = Array.isArray(categories)
                            ? categories
                            : [categories].filter(Boolean);

                        if(query !== '') {
                            searchStoredQuery = query;
                        }

                        return {
                            query: decodeURIComponent(query),
                            year: allYear.map(decodeURIComponent),
                            type: allTypes.map(decodeURIComponent),
                            categories: allCategories.map(decodeURIComponent),
                        };
                    }
                }),

                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[indexName];
                        return {
                            query: indexUiState.query,
                            type:
                                indexUiState.refinementList && indexUiState.refinementList.type,
                            year:
                                indexUiState.refinementList && indexUiState.refinementList.year,
                            categories:
                                indexUiState.refinementList && indexUiState.refinementList.categories,
                        }
                    },
                    routeToState(routeState) {
                        return {
                            [indexName]: {
                                query: routeState.query,
                                refinementList: {
                                    type: routeState.type,
                                    year: routeState.year,
                                    categories: routeState.categories,
                                }
                            },
                        };
                    },
                }
            }
        });

        // Stats
        const renderStats = (renderOptions, isFirstRender) => {
            const {
                nbHits,
                areHitsSorted,
                nbSortedHits,
                processingTimeMS,
                page,
                nbPages,
                hitsPerPage,
                query,
                widgetParams,
            } = renderOptions;

            if (isFirstRender) {
                return;
            }

            let count = '';
            const resultFrom = page * hitsPerPage;
            const resultTill = resultFrom + Math.min(nbHits - resultFrom, hitsPerPage);

            if (nbHits > 1) {
                count = `<strong class="title">${nbHits} Results</strong>`;
            } else if (nbHits === 1) {
                count = '<strong class="title">1 Result</strong>';
            } else {
                count = '<strong class="title">No Results</strong>';
            }

            if (nbPages < 2) {
                this.buttonMore.classList.add('hidden')
            } else {
                this.buttonMore.classList.remove('hidden')
            }

            widgetParams.container.innerHTML = `${count}`;
        };

        const customStats = connectStats(renderStats);

        const renderSearchBox = (renderOptions, isFirstRender) => {
            const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

            if (isFirstRender) {
                const input = document.createElement('input');
                input.setAttribute('type', 'search');
                input.setAttribute('placeholder', 'Search');
                input.setAttribute('id', 'search-adv-input');

                if(searchStoredQuery) {
                    input.value = searchStoredQuery
                }

                input.addEventListener('focus', () => {
                    searchWrapper.classList.add('focus');
                });

                input.addEventListener('blur', () => {
                    searchWrapper.classList.remove('focus');
                });

                const urlParams = new URLSearchParams(window.location.search);
                const searchParam = urlParams.get('search');

                if(searchParam) {
                    input.value = searchParam;
                    refine(searchParam)
                }

                input.addEventListener('input', event => {
                    refine(event.target.value);
                });

                widgetParams.container.appendChild(input);
            }
        };

        const customSearchBox = connectSearchBox(
            renderSearchBox
        );

        const renderSortBy = (renderOptions, isFirstRender) => {
            const {
                options,
                currentRefinement,
                hasNoResults,
                refine,
                widgetParams,
            } = renderOptions;

            widgetParams.container.innerHTML = `
            ${ options
                .map(option => `
                    <li>
                        <label class="nice-form is-bayside">
                            <input type="radio" class="square" name="result" value="${option.value}" ${option.value === currentRefinement ? 'checked=""' : ''} >
                            <span class="nice-label">${option.label}</span>
                        </label>
                    </li>
        `
                ).join('') }
            `;

            this.orderByButtons = widgetParams.container.querySelectorAll('input[type="radio"]');
            this.orderByIndex = currentRefinement;
            if(this.orderByButtons) {
                Array.from(this.orderByButtons).forEach(button => {
                    button.addEventListener('click', () => {
                        if(this.orderByIndex !== button.value) {
                            refine(button.value);
                            this.orderByIndex = button.value;
                        }
                    });
                });
            }
        };

        const customSortBy = connectSortBy(renderSortBy);
        const typeWeight = {
            'Article' : 3,
            'Company Announcement': 2,
            'Podcast': 2,
            'Special Report': 1,
            'Newsletter': 1,
            'Employee Bio' : 0
        }

        const renderAuthor = (hit, bindEvent) => {
            this.authorIndex++;
            return `
                    <div class="result-card-wrap">
                        <a href="${ hit.url }" ${ bindEvent('click', hit, 'Search - Click on Author') } class="result-card ${this.authorIndex % 2 === 0 ? 'is-bayside' : ''}">
                            <div class="bg-img">
                                <img src="/wp-content/themes/a16z/assets/images/search/pattern-${this.authorIndex % 2 === 0 ? '2' : '1'}.png" alt="">
                            </div>
                            <div class="txt">
                                <strong class="name">${ hit.title }</strong>
                                ${ hit.bio ? `<p>${ hit.title } ${ hit.bio }</p>` : ``}
                            </div>
                            <div class="img">
                                ${ hit.avatar ? `<img src="${ hit.avatar }" alt="${ hit.title }"/>` : ``}
                            </div>
                        </a>
                    </div>
            `
        };

        const renderPost = (hit, bindEvent) => {
            return `
                <a href="${ hit.url }" ${ bindEvent('click', hit, 'Search - Click on Post') }>
                    <div class="post">
                        <h3 class="title"><strong>${ hit.title }</strong>${ hit.is_featured && hit.type !== 'Page' ? '<span class="tag is-featured">Featured</span>' : '' }</h3>
                        <div class="author">
                            ${ hit.type === 'Podcast' ? '<span class="icon-headphone"></span>' : '' }
                            ${ hit.type === 'Company Announcement' ? '<span class="icon-speaker"></span>' : '' }
                            ${ hit.type === 'Page' ? '' : hit.author }
                        </div>
                    </div>
                    <div class="desc">
                        <p>${ hit.desc }</p>
                    </div>
                </a>
            `
        }

        this.search.addWidgets([
            configure({
                hitsPerPage: 10,
                facets: ['is_hidden'],
                facetsRefinements: {
                    'is_hidden': [false],
                }
            }),

            customSearchBox({
                container: document.querySelector('#search-adv-field'),
            }),

            customSortBy({
                container: document.querySelector('#search-adv-sort-by'),
                items: [
                    { label: 'Most Relevant', value: this.index },
                    { label: 'Most Recent', value: this.indexByDate },
                ],
            }),

            refinementList({
                container: '#filter-year',
                attribute: 'year',
                sortBy: ['name:desc'],
                limit: 99,
                cssClasses: {
                    list: ''
                },
                templates: {
                    item:
                        `<label class="nice-form is-bayside">
                            <input {{#isRefined}}checked{{/isRefined}} value="{{ label }}" type="checkbox">
                            <span class="nice-label">{{ label }}</span>
                        </label>
                        `
                }
            }),

            refinementList({
                container: '#filter-type',
                limit: 99,
                attribute: 'type',
                cssClasses: {
                    list: ''
                },
                templates: {
                    item:
                        `
                        <label class="nice-form is-bayside">
                            <input {{#isRefined}}checked{{/isRefined}} value="{{ label }}" type="checkbox">
                            <span class="nice-label">{{ label }}</span>
                        </label>
                        `
                },
                transformItems(items) {
                    return items
                        .map((item) => ({ ...item, weight: typeWeight[item.label] }))
                        .sort((a, b) => b.weight - a.weight);
                },
            }),

            refinementList({
                container: '#filter-category',
                attribute: 'categories',
                sortBy: ['name:asc'],
                limit: 99,
                cssClasses: {
                    list: 'custom-checkbox'
                },
                templates: {
                    item:
                        `<label class="nice-form is-bayside">
                            <input {{#isRefined}}checked{{/isRefined}} value="{{ label }}" type="checkbox">
                            <span class="nice-label">{{ label }}</span>
                        </label>
                        `
                },
                transformItems: (items) => {
                    return items.filter(item => {
                        return item.label !== 'Uncategorized'
                    });
                },
            }),

            clearRefinements({
                container: '#clear-refinements',
                cssClasses: {
                    button: [
                        ' link',
                    ],
                },
                templates: {
                    resetLabel: 'Clear Filters',
                },
            }),

            hits({
                container: this.searchResults,
                templates: {
                    item: (hit, bindEvent) => {
                        return hit.is_author ? renderAuthor(hit, bindEvent) : renderPost(hit, bindEvent)
                    },
                    empty: `<div class="suggestion-block">${ searchNoResults.innerHTML }</div>`
                },
                cssClasses: {
                    list: 'result-list',
                    item: 'post-row',
                },
                transformItems: (items) => {
                    if (this.appendPosts) {
                        this.appendPosts = false
                        items = window.featured_posts_list.concat(items)
                    }

                    return items;

                    /*return items.sort((a, b) => {
                        if(a.is_author && b.is_author) {
                            if (a.title > b.title) {
                                return 1;
                            }
                            if (b.title > a.title) {
                                return -1;
                            }
                        }

                        return a.is_author - b.is_author
                    })*/
                }
            }),

            customStats({
                container: document.querySelector('#search-adv-stats'),
            })
        ])

        this.buttonMore.addEventListener('click', (event) => {
            event.preventDefault();
            this.search.helper.state.hitsPerPage += 10;
            this.search.refresh();
        })

        if(this.searchResultsSuggested) {
            this.buttonMoreSuggested.addEventListener('click', (event) => {
                event.preventDefault();
                const hiddenEls = [...this.searchResultsSuggested.querySelectorAll('.post-row.hidden')];
                if (hiddenEls) {
                    if (hiddenEls.length < 10) {
                        this.buttonMoreSuggested.remove();
                    }

                    hiddenEls.slice(0, 10).forEach(item => {
                        item.classList.remove('hidden')
                    })
                }
            })
        }

        const insightsMiddleware = createInsightsMiddleware({
            insightsClient: aa,
            insightsInitParams: {
                useCookie: true,
            }
        })

        this.search.use(insightsMiddleware)

        this.search.start()

        $('#search-adv-results').on('click', '[data-search-suggestion]', (e) => {
            event.preventDefault();
            const suggestion = e.target.dataset.searchSuggestion;
            const input = document.getElementById('search-adv-input');
            input.value = suggestion;
            this.search.helper.state.query = suggestion;
            this.search.refresh();
            input.focus();
        });
    }
}

export default AlgoliaSearch
